import React, { useRef } from 'react';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphHeroCarouselItem = ({
  entity,
  index,
  sliderRef,
}) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  const timeoutRef = useRef(null);
  const displaySlide = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(parseInt(index));
      }
    }, 100);
  };

  return (
    <CoreLink to={linkUrl}>
      <div
        className="ParagraphHeroCarouselItem"
        onMouseEnter={displaySlide}
      >
        <div className="ParagraphHeroCarouselItem__wrapper">

          <div className="ParagraphHeroCarouselItem__wrapper__title">
            <h3>{title}</h3>
          </div>

          <div className="ParagraphHeroCarouselItem__wrapper__icon">
            <span className="ParagraphHeroCarouselItem__wrapper__link__span">
              <i className="icon icon-arrow-right-filled icon-variant-4" />
            </span>
          </div>

        </div>
      </div>
    </CoreLink>
  );
};

export default ParagraphHeroCarouselItem;
